
import BrifecaseTick from "../../../assets/outline/BrifecaseTick.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BrifecaseTickIcon({ className, dataTestid = "BrifecaseTickIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <BrifecaseTick data-testid={dataTestid} className={classes} {...rest} />
  );
}
